import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import { en } from './locales/en'
import { es } from './locales/es'
import { pl } from './locales/pl'
import { vi } from './locales/vi'

export const defaultNS = 'translation'
export const resources = {
  en,
  es,
  vi,
  pl,
} as const

void i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  ns: ['translation'],
  defaultNS,
  resources,
  interpolation: { escapeValue: false },
})

export default i18n
